export const FETCH_COIN_SETTING = 'FETCH_COIN_SETTING';
export const FETCH_COIN_SETTING_FAILED = 'FETCH_COIN_SETTING_FAILED';
export const FETCH_COIN_SETTING_SUCCEED = 'FETCH_COIN_SETTING_SUCCEED';

export const FETCH_MARKET = 'FETCH_MARKET';
export const FETCH_MARKET_FAILED = 'FETCH_MARKET_FAILED';
export const FETCH_MARKET_SUCCEED = 'FETCH_MARKET_SUCCEED';

export const FETCH_ALL_COIN = 'FETCH_ALL_COIN';
export const FETCH_ALL_COIN_FAILED = 'FETCH_ALL_COIN_FAILED';
export const FETCH_ALL_COIN_SUCCEED = 'FETCH_ALL_COIN_SUCCEED';

export const FETCH_LIMIT_WITHDRAWAL = 'FETCH_LIMIT_WITHDRAWAL';
export const FETCH_LIMIT_WITHDRAWAL_SUCCEED = 'FETCH_LIMIT_WITHDRAWAL_SUCCEED';
export const FETCH_LIMIT_WITHDRAWAL_FAILED = 'FETCH_LIMIT_WITHDRAWAL_FAILED';

export const FETCH_CRYPTO_SETTING = 'FETCH_CRYPTO_SETTING';
export const FETCH_CRYPTO_SETTING_SUCCEED = 'FETCH_CRYPTO_SETTING_SUCCEED';
export const FETCH_CRYPTO_SETTING_FAILED = 'FETCH_CRYPTO_SETTING_FAILED';

export const FETCH_HASH_SETTING = 'FETCH_HASH_SETTING';
export const FETCH_HASH_SETTING_SUCCEED = 'FETCH_HASH_SETTING';
export const FETCH_HASH_SETTING_FAILED = 'FETCH_HASH_SETTING';

export const WS_EVENT_LAST_PRICE_UPDATED = 'WS_EVENT_LAST_PRICE_UPDATED';
